// src/utils/id.js
export const uid = () =>
    (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `id_${Math.random().toString(16).slice(2)}_${Date.now()}`;
